import { EAdminGrowthInvestmentCategoryType } from "../../Enum/EAdminGrowthInvestmentCategoryType"
import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"

export class AdminGrowthInvestment {
  id: number

  title: string

  categoryType: EAdminGrowthInvestmentCategoryType

  amount: number

  investmentDateUtc: string

  commercialOriginType: ECommercialOriginType

  commercialReferralCode?: string

  campaignName?: string

  channelName?: string

  responsibleName?: string

  targetAudience?: string

  expectedReturnAmount?: number

  leadsGenerated: number

  interestedCount: number

  conversionsCount: number

  acquiredCustomersCount: number

  associatedRevenueAmount: number

  notes?: string

  createdAtUtc?: string

  updatedAtUtc?: string

  constructor(data: Partial<AdminGrowthInvestment> = {}) {
    this.id = data.id ?? 0

    this.title = data.title ?? ""

    this.categoryType = data.categoryType ?? EAdminGrowthInvestmentCategoryType.OnlineAds

    this.amount = data.amount ?? 0

    this.investmentDateUtc = data.investmentDateUtc ?? new Date().toISOString()

    this.commercialOriginType = data.commercialOriginType ?? ECommercialOriginType.Undefined

    this.commercialReferralCode = data.commercialReferralCode

    this.campaignName = data.campaignName

    this.channelName = data.channelName

    this.responsibleName = data.responsibleName

    this.targetAudience = data.targetAudience

    this.expectedReturnAmount = data.expectedReturnAmount

    this.leadsGenerated = data.leadsGenerated ?? 0

    this.interestedCount = data.interestedCount ?? 0

    this.conversionsCount = data.conversionsCount ?? 0

    this.acquiredCustomersCount = data.acquiredCustomersCount ?? 0

    this.associatedRevenueAmount = data.associatedRevenueAmount ?? 0

    this.notes = data.notes

    this.createdAtUtc = data.createdAtUtc

    this.updatedAtUtc = data.updatedAtUtc
  }
}
